import { add, format, sub } from 'date-fns';
import { DISPLAY_DATE_TIME_FULL_MONTH } from '@acorn-portal/shared/src/utils/constants';

export const getEndDate = (startDate: Date): string => {
	const startDatePlus30Days = add(startDate, { days: 30 });
	const remove1Minute = sub(startDatePlus30Days, { minutes: 1 });
	return format(remove1Minute, DISPLAY_DATE_TIME_FULL_MONTH);
};
